import { BaseVectorFilter } from "../BaseVectorFilter";
import { SegmentFilterContext, VectorSegment } from "../VectorSprite";

/**
 * Randomly omit segments when rendering (broken effect)
 */
export class BrokenFilter extends BaseVectorFilter {
  constructor(
    private omitProbability: number = 0.3,
    private seed: number = Math.random() * 1000,
  ) {
    super();
  }

  apply(
    segments: VectorSegment[],
    context: SegmentFilterContext,
  ): VectorSegment[] {
    return segments.filter((_segment, i) => {
      // Use deterministic random based on segment index and time
      const hash =
        (i * 1000 + this.seed + Math.floor(context.totalTime * 10)) % 1000;
      return hash / 1000 > this.omitProbability;
    });
  }
}
